import fetch from "@/utils/fetch";

// 教育局审核列表
export function getFundApplyListByEduBatch(data) {
    const formData = new URLSearchParams()
    formData.append('applyState', data.applyState || 0)
    formData.append('pageNo', data.pageNo || 1)
    formData.append('pageSize', data.pageSize || 10)
    formData.append('useInfo', data.useInfo || '')
    formData.append('type',12)
    return fetch({
        url:'structure/fundApply/getFundApplyListByEduBatch',
        method:'post',
        params: formData
    })
}



// WEBPACK FOOTER //
// ./src/api/iPayment/homePage.js